import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { StepsWrapper, ScheduleDateTooltip } from "./styles";
import { Steps, Tooltip } from "antd";
import { find, last, includes } from "lodash";
import {
  ExclamationCircleOutlined,
  CheckCircleOutlined
} from "@ant-design/icons";
import { todayDate } from "../../utils/commonUtil";
import moment from "moment";

// Grant status mapper with Timeline
const GrantStatusMapper = {
  "Research proceeding": "In Research",
  "Research complete": "Research Completed",
  "Approved": "Grant Approved",
  "Cancelled": "Cancelled",
  "Reversed": "Reversed",
  "Denied": "Grant Denied",
  "Payment issued": "Payment Sent",
  "Payment completed": "Payment Completed",
  "Reversed/Refunded": "Reversed and Refunded"
}

export const TimeLine = props => {
  const [grantLifeCycles, setGrantLifeCycles] = useState([]);
  const [direction, setDirection] = useState(
    window.innerWidth <= 767 ? "vertical" : "horizontal"
  );
  const {
    grantTimeline,
    enteredDate,
    fastPass,
    scheduleIdForSpawns,
    isGrantAgreementPayment,
    startDate,
    grantAgreementId
  } = props;
  const { Step } = Steps;
  const scheduleDate =
    moment(startDate).valueOf() > moment(todayDate()).valueOf();

  useEffect(() => {
    window.addEventListener("resize", resize);
    setGrantLifeCycles(makeChangeGrantStatus);
  }, []);

  function resize() {
    setDirection(window.innerWidth <= 767 ? "vertical" : "horizontal");
  }

  // Disable timeline status
  const makeDisableTimeLine = (grantStatus = []) => {
    return (
      grantLifeCycles.length &&
      includes(grantStatus, last(grantLifeCycles).status)
    );
  };

  const startingTimeLineComponent = () => {
    let title = "";

    if (isGrantAgreementPayment)
      title = `Grant Payment of Agreement Id: ${grantAgreementId}`;
    else if (scheduleIdForSpawns)
      title = `Recurring schedule of schedule Id: ${scheduleIdForSpawns}`;
    else if (scheduleDate)
      title = (
        <>
          <ScheduleDateTooltip> Schedule Date</ScheduleDateTooltip>
          {startDate}
        </>
      );

    return scheduleIdForSpawns ||
      isGrantAgreementPayment ||
      (scheduleDate && !fastPass) ? (
      <Tooltip title={title} placement={"topLeft"}>
        <CheckCircleOutlined className="pointer" />
      </Tooltip>
    ) : (
      <CheckCircleOutlined />
    );
  };

  const startingTimeLine = [
    {
      name:
        scheduleIdForSpawns || isGrantAgreementPayment
          ? "Grant Received"
          : "Grant Submitted",
      icon: startingTimeLineComponent(),
      date: enteredDate,
      show: true
    }
  ];

  const fasPassStatusStartingTimeLine = [
    {
      name:
        scheduleIdForSpawns || isGrantAgreementPayment
          ? "Grant Received"
          : "Grant Submitted",
      icon: startingTimeLineComponent(),
      date: enteredDate,
      show: true
    },
    {
      name: "Research Completed",
      icon: <CheckCircleOutlined />,
      date: enteredDate,
      show: true
    }
  ];

  const DefaultTimeLineGrantStatus = [
    {
      name: "Research Completed",
      icon: <CheckCircleOutlined />,
      date: "",
      show: false
    },
    {
      name: "In Research",
      icon: <CheckCircleOutlined />,
      date: "",
      show:
        makeDisableTimeLine(["In Research"]) || grantLifeCycles.length === 0
          ? true
          : false
    },
    {
      name: "Grant Approved",
      icon: <CheckCircleOutlined />,
      date: "",
      show: makeDisableTimeLine(["Grant Denied", "Cancelled"]) ? false : true
    },
    {
      name:
        (scheduleIdForSpawns || isGrantAgreementPayment) &&
        makeDisableTimeLine(["Grant Approved"])
          ? "Grant Scheduled"
          : "Payment Sent",
      icon: <CheckCircleOutlined />,
      date:
        (scheduleIdForSpawns || isGrantAgreementPayment) &&
        makeDisableTimeLine(["Grant Approved"])
          ? startDate
          : "",
      show: makeDisableTimeLine(["Grant Denied", "Cancelled"]) ? false : true
    },
    {
      name: "Payment Completed",
      icon: <CheckCircleOutlined />,
      date: "",
      show: makeDisableTimeLine(["Grant Denied", "Cancelled", "Reversed"])
        ? false
        : true
    },
    {
      name: "Cancelled",
      icon: <ExclamationCircleOutlined className="error" />,
      date: "",
      show: false
    },
    {
      name: "Grant Denied",
      icon: <ExclamationCircleOutlined className="error" />,
      date: "",
      show: false
    },
    {
      name: "Reversed and Refunded",
      icon: <ExclamationCircleOutlined className="error" />,
      date: "",
      show: false
    },
    {
      name: "Reversed",
      icon: <ExclamationCircleOutlined className="error" />,
      date: "",
      show: false
    }
  ];

  // Mapping Timeline grant status with Donor portal status
  const makeChangeGrantStatus = () => {
    return grantTimeline.map(item => {
      return {
        ...item,
        status: GrantStatusMapper[item.grantStatus]
      };
    });
  };

  const makeGrantTimeLineData = () => {
    return DefaultTimeLineGrantStatus.map(grantStatus => {
      let resultObj = find(grantLifeCycles, function(o) {
        return grantStatus.name === o.status;
      });
      if (resultObj) {
        return { ...grantStatus, date: resultObj.date, show: true };
      } else {
        return { ...grantStatus, status: "wait" };
      }
    });
  };

  const GrantTimeLineSteps = () => {
    const grantStatus = makeGrantTimeLineData();
    const initialTimeLine = fastPass
      ? [...fasPassStatusStartingTimeLine]
      : [...startingTimeLine];
    const grantStatusData = [];

    grantStatus.unshift(...initialTimeLine);
    grantStatus.forEach(item => {
      if (item.show)
        grantStatusData.push(
          <Step title={item.name} icon={item.icon} description={item.date} />
        );
    });

    return grantStatusData;
  };

  const timeLineStatusCount = GrantTimeLineSteps().length;
  const widthInStatus = timeLineStatusCount > 2 ? 17 : 14;
  const width =
    timeLineStatusCount * widthInStatus > 100
      ? 100
      : timeLineStatusCount * widthInStatus;
  const current = fastPass
    ? grantTimeline && grantTimeline.length + 1
    : grantTimeline && grantTimeline.length;

  return (
    <div className="grant-time-line mb-25" style={{ width: `${width}%` }}>
      <StepsWrapper
        current={current}
        labelPlacement="vertical"
        direction={direction}
      >
        {GrantTimeLineSteps()}
      </StepsWrapper>
    </div>
  );
};

export default withRouter(TimeLine);
